// extracted by mini-css-extract-plugin
export default {"wrapper":"JuPa8zpdUVM4pd1qMcnE","breadcrumb":"CAUuzLAdHBUhFV_s9FvQ","titleWithCurrency":"y_KNielaGflimnChQB6Z","title":"Vnl5nBRwPeJ3ZNk91PAn"};